import { IconsProps } from '@/types/shared'
import React from 'react'

const ShareIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.0198 19.9298V21.9498C15.0298 21.7498 16.8598 20.9498 18.3398 19.7398L16.9198 18.3098C15.8098 19.1698 14.4798 19.7498 13.0198 19.9298Z"
                    fill="currentColor"
                />
                <path
                    d="M4.02979 11.9998C4.02979 7.9498 7.05978 4.5898 10.9798 4.0698V2.0498C5.94978 2.5798 2.02979 6.8398 2.02979 11.9998C2.02979 17.1598 5.94978 21.4198 10.9798 21.9498V19.9298C7.05978 19.4098 4.02979 16.0498 4.02979 11.9998Z"
                    fill="currentColor"
                />
                <path
                    d="M19.9498 10.9998H21.9698C21.7698 8.9898 20.9698 7.1598 19.7598 5.6798L18.3298 7.10981C19.1898 8.20981 19.7698 9.5398 19.9498 10.9998Z"
                    fill="currentColor"
                />
                <path
                    d="M18.3398 4.2598C16.8598 3.0498 15.0198 2.2498 13.0198 2.0498V4.0698C14.4798 4.2498 15.8098 4.8298 16.9198 5.6898L18.3398 4.2598Z"
                    fill="currentColor"
                />
                <path
                    d="M18.3298 16.8998L19.7598 18.3198C20.9698 16.8398 21.7698 15.0098 21.9698 12.9998H19.9498C19.7698 14.4598 19.1898 15.7898 18.3298 16.8998Z"
                    fill="currentColor"
                />
                <path
                    d="M15.9998 11.0998C15.9998 8.60981 14.0998 6.9998 11.9998 6.9998C9.89979 6.9998 7.99979 8.60981 7.99979 11.0998C7.99979 12.7598 9.32979 14.7298 11.9998 16.9998C14.6698 14.7298 15.9998 12.7598 15.9998 11.0998ZM11.9998 11.9998C11.4098 11.9998 10.9298 11.5198 10.9298 10.9298C10.9298 10.3398 11.4098 9.8598 11.9998 9.8598C12.5898 9.8598 13.0698 10.3398 13.0698 10.9298C13.0698 11.5198 12.5898 11.9998 11.9998 11.9998Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default ShareIcons
